import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import Button from "../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../Reusable/BaseURL";
import IndentCreatePageForm from "../../../purchaseFormPages/IndentCreatePageForm";
import { SeveritySelect } from "../../../Reusable/SeveritySelect";
import MyTextarea from "../../../Reusable/MyTextarea";

import ClickOutHandler from "react-clickout-handler";
import { IndentCreateDivisionSelect } from "../../../Reusable/IndentCreateDivisionSelect";
import MyInput from "../../../Reusable/MyInput";
import { ItemByDivisionSelect } from "../../../Reusable/ItemByDivisionSelect";
import { BrandByItemSelect } from "../../../Reusable/BrandByItemSelect";
import { IndentUnitSelect } from "../../../Reusable/IndentUnitSelect";
import { useNavigate } from "react-router-dom";
import { IndentItemSeveritySelect } from "./IndentItemSeveritySelect";
import MainIndentCreatePageForm from "./MainIndentCreatePageForm";

export default function IndentCreate() {
  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
  } = useContext(UserContext);

  const [division, setDivision] = useState("");
  const [item, setItem] = useState("");
  const [brand, setBrand] = useState("");
  const [unit, setUnit] = useState("");
  const [qty, setQty] = useState("");
  const [date, setDate] = useState("");
  // const [severity, setSeverity] = useState("Normal");
  const [itemSeverity, setItemSeverity] = useState("Normal");
  const [remark, setRemark] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allIndentItem, setAllIndentItem] = useState([]);
  const [cacheItemId, setCacheItemId] = useState("");
  const [myCacheDivision, setMyCacheDivision] = useState("");

  const navigate = useNavigate();

  // TODAY CURRENT DATE DEFAULT SET
  const currentDateFunc=()=>{
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    return setDate(formattedDate);
  }

  useEffect(()=>{
    currentDateFunc()
  },[])

  useEffect(() => {
    postCacheItemDate();
  }, [date]);

  // useEffect(() => {
  //   getAllIndentCreated();
  //   getUnsavedItemList();
  // }, []);

  // OnBlur DATE
  async function postCacheItemDate() {
    const selectedData = { date: date };
    const response = await fetch(`${BaseURL}/purchase/indent/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
  }
  // OnBlur REMARK
  async function postCacheItemRemark() {
    const selectedData = { remarks: remark };
    const response = await fetch(`${BaseURL}/purchase/indent/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
    // console.log("remarks", data);
    // console.log("remarks", selectedData);
  }

  async function getUnsavedItemList() {
    const res = await fetch(`${BaseURL}/purchase/indent/getcache`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // const cacheItems = createRes.data.items || [];
          const cacheItems =
            createRes.data !== null ? createRes.data.items : [];
          // const reverseCacheItems = cacheItems.reverse();
          // setUnsavedIndentItem(createRes.data.items || []);
          setUnsavedIndentItem(cacheItems);

          // const mygetdivision = createRes.data?.items[0];
          // const cacheDivision = mygetdivision.division;
          // setMyCacheDivision(cacheDivision || "");

          // const mygetdivision =
          //   createRes.data !== null ? createRes.data?.items[0] : {};
          // const cacheDivision = mygetdivision?.division || "";
          // setMyCacheDivision(cacheDivision || "");

          const myCacheDiv = createRes?.data?.division;
          const myCacheDate = createRes?.data?.date;
          const myCacheRemark = createRes?.data?.remarks;
          setMyCacheDivision(myCacheDiv || "");
          // setDate(myCacheDate ? myCacheDate : date);
          setRemark(myCacheRemark || "");

          setSpinner(false);
        }
      });
  }
  // async function getAllIndentCreated() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getall`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setAllIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }

  // ADD INDENT ITEM
  async function addIndentItem(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("item_id", item.value || "");
    // formData.append("brand_id", brand.value || "");
    // formData.append("unit_id", unit.value || "");
    // formData.append("qty", qty || "");

    if (division !== "") {
      setItemSubmitDisable(true);
      const formData = {
        severity: itemSeverity.value || "",
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty,
      };

      const res = await fetch(`${BaseURL}/purchase/indent/setcacheitems`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resdata) => resdata.json())
        .then((createRes) => {
          if (createRes.status) {
            setAddMoreToggle(false);
            getUnsavedItemList();
            setItem("");
            setBrand("");
            setUnit("");
            setQty("");
            toast.success("Added on lists");
            setItemSubmitDisable(false);
          }
          if (createRes.status === false) {
            setItemSubmitDisable(false);
          }
          if (createRes?.error?.message.item_id) {
            toast.error(createRes.error.message.item_id);
          } else if (createRes?.error?.message.brand_id) {
            toast.error(createRes.error.message.brand_id);
          } else if (createRes?.error?.message.unit) {
            toast.error(createRes.error.message.unit);
          } else if (createRes?.error?.message.qty) {
            toast.error(createRes.error.message.qty);
          } else if (createRes?.error?.message.severity) {
            toast.error(createRes.error.message.severity);
          }
        });
    } else {
      toast.error("First Select Division.!");
      setItemSubmitDisable(false);
    }
  }

  // create
  // const itemId = unsavedIndentItem.map((item, index) => item.id);
  async function createDivision(e) {
    e.preventDefault();
    if (unsavedIndentItem.length <= 0) {
      toast.error("Please add items before submit.");
      return;
    }
    setSubmitDisable(true);
    const formData = {
      date: date,
      // severity: severity.value,
      remarks: remark,
      division: division.value,
    };

    const res = await fetch(`${BaseURL}/purchase/indent/save`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          getUnsavedItemList();
          toast.success("Success");
          setDivision("");
          setItem("");
          setBrand("");
          setUnit("");
          setQty("");

          setDate("");
          // setSeverity("");
          setRemark("");
          navigate("/purchase/pending-indent-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.date) {
          toast.error(createRes.error.message.date);
        } else if (createRes?.error?.message.severity) {
          toast.error(createRes.error.message.severity);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    // without endpoint hit===========
    setEditDisable(true);
          setChangingSelect(true);
          setAddMoreToggle(true);
          setSubmitAction("update");

          setDivision(editData.division || "");
          setItem(editData.item_name || "");
          setItemSeverity(editData.severity || "");
          setBrand(editData.brand || "");
          setUnit(editData.unit || "");
          setQty(editData.qty || "");
          setEditDisable(false);
          toast.success("Go to update form")

    // with api hit ============
    // setEditDisable(true);
    // fetch(`${BaseURL}/purchase/indent/getcacheitem/${id}`, {
    //   method: "GET",
    //   headers: {
    //     Accept: "application/json",
    //     Authorization: `Bearer ${loginData.token}`,
    //   },
    // })
    //   .then((res) => res.json())
    //   .then((selectedRecord) => {
    //     if (selectedRecord.status) {
    //       setChangingSelect(true);
    //       setAddMoreToggle(true);
    //       setSubmitAction("update");

    //       setDivision(selectedRecord.data.division || "");
    //       setItem(selectedRecord.data.item_name || "");
    //       setItemSeverity(selectedRecord.data.severity || "");
    //       setBrand(selectedRecord.data.brand || "");
    //       setUnit(selectedRecord.data.unit || "");
    //       setQty(selectedRecord.data.qty || "");
    //       setEditDisable(false);
    //     }
    //     if (selectedRecord.status === false) {
    //       setEditDisable(false);
    //     }
    //   });
    // setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateIndentItem(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    if (division !== "") {
      const formData = {
        severity: itemSeverity.value || "",
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || "",
      };
      const updRes = await fetch(
        `${BaseURL}/purchase/indent/updatecacheitem/${id}`,
        {
          method: "PATCH",
          body: JSON.stringify(formData),
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({name: divisionName}),
        }
      )
        .then((res) => res.json())
        .then((upd) => {
          if (upd.status) {
            getUnsavedItemList();
            setGetId(0);
            setItem("");
            setBrand("");
            setUnit("");
            setQty("");

            setSubmitAction("submit");
            setAddMoreToggle(false);
            toast.success("Updated");
            setUpdateDisable(false);
          }
          if (upd.status === false) {
            setUpdateDisable(false);
          }
          if (upd?.error?.message.item_id) {
            toast.error(upd.error.message.item_id);
          } else if (upd?.error?.message.brand_id) {
            toast.error(upd.error.message.brand_id);
          } else if (upd?.error?.message.unit) {
            toast.error(upd.error.message.unit);
          } else if (upd?.error?.message.qty) {
            toast.error(upd.error.message.qty);
          } else if (upd?.error?.message) {
            toast.error(upd.error.message);
          }
        });
    }
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);
    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
  }

  function cancelPopup() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
    setSubmitAction("submit");
  }

  function popupCreateIndentOnClickOut() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");
    setSubmitAction("submit");
    // setDivision("");
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Create Indent
          </div>
          <div className="mb-2">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* LEFT PART  */}
              <div className="px-2 w-full mb-6">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:gap-x-6">
                    <div className="mb-2 w-full">
                      <label>
                        Division{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <IndentCreateDivisionSelect
                        selectedOption={division}
                        setSelectedOption={setDivision}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                        setEmpty={setItem}
                        addMoreToggle={addMoreToggle}
                        unsavedIndentItem={unsavedIndentItem}
                        setUnsavedIndentItem={setUnsavedIndentItem}
                        myCacheDivision={myCacheDivision}
                        getUnsavedItemList={getUnsavedItemList}
                        setBrand={setBrand}
                        setItem={setItem}
                        setUnit={setUnit}
                        setQty={setQty}
                      />
                    </div>

                    {/* <div className="mb-2 w-full">
                      <label>
                        Severity{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <SeveritySelect
                        selectedOption={severity}
                        setSelectedOption={setSeverity}
                      />
                    </div> */}
                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      onBlur={() => postCacheItemRemark()}
                    />
                    <div className="mb-2 w-full">
                      <label className="mr-2 block mb-[4px]">
                        Date <span className="text-red-500 font-bold">*</span>
                      </label>
                      <input
                        // onBlur={() => postCacheItemDate()}
                        className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}

              {/* RIGHT PART  */}
              <div className="bg-[#8CDDCD] rounded-xl p-3">
                <div className="mb-2 grid grid-cols-2 gap-x-2">
                  <div className="mb-2 w-full">
                    <label>
                      Severity <span className="text-red-500 font-bold">*</span>
                    </label>
                    <IndentItemSeveritySelect
                      selectedOption={itemSeverity}
                      setSelectedOption={setItemSeverity}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>
                      Item <span className="text-red-500 font-bold">*</span>
                    </label>
                    <ItemByDivisionSelect
                      divisionLabel={division && division}
                      selectedOption={item}
                      setSelectedOption={setItem}
                      setEmpty={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>
                      Brand <span className="text-red-500 font-bold">*</span>
                    </label>
                    <BrandByItemSelect
                      itemItemId={item && item.value}
                      selectedOption={brand}
                      setSelectedOption={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>
                      Unit <span className="text-red-500 font-bold">*</span>
                    </label>
                    <IndentUnitSelect
                      selectedOption={unit}
                      setSelectedOption={setUnit}
                      unitByItem={item}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <MyInput
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                    label="Quantity"
                    type="number"
                    className="w-full"
                    mendatory="*"
                  />
                </div>
                <div className="flex items-center justify-center gap-1">
                  {submitAction === "submit" && (
                    <Button
                      disabled={itemSubmitDisable}
                      type="submit"
                      onClick={(e) => addIndentItem(e)}
                      className="!bg-yellow-600"
                    >
                      {itemSubmitDisable ? "Wait.." : "Add Item"}
                    </Button>
                  )}
                  {submitAction !== "submit" && (
                    <Button
                      disabled={updateDisable}
                      type="submit"
                      onClick={(e) => updateIndentItem(e, getId)}
                      className="!bg-yellow-600"
                    >
                      {updateDisable ? "Wait.." : "Update Item"}
                    </Button>
                  )}
                  <Button
                    onClick={() => cancelPopup()}
                    className="!bg-gray-200 !text-black"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
              {/* END RIGHT PART  */}
            </div>
          </div>

          {/* ITEM LIST FORM  */}
          <div className="w-full px-2 mb-4">
            <MainIndentCreatePageForm
              editBtn={editBtn}
              firstPageList={getUnsavedItemList}
              links={links}
              firstPage={unsavedIndentItem}
              setGetId={setGetId}
              spinner={spinner}
              totalNo={totalNo}
              from={from}
              to={to}
              addMoreToggle={addMoreToggle}
              setAddMoreToggle={setAddMoreToggle}
              editDisable={editDisable}
            />
          </div>

          {submitAction === "submit" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                disabled={submitDisable}
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                onClick={(e) => createDivision(e)}
              >
                {submitDisable ? "Wait.." : "Submit"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
